import React, { Component } from 'react';
import { Input } from '@driftt/tide-core'
import PropTypes from 'prop-types'
import config from 'config'
import './style.css'

class AppUrlView extends Component {
  
  static propTypes = {
    appId: PropTypes.string.isRequired,
  }

  render() {
    const { appId } = this.props
    const authUrl = `${config.CUSTOMER_WEB_URL}/settings/setup/${appId}`

    return (
      <div className="app-url-view">
        <span className="app-url-view-page-title">
          Drift Internal URL
        </span>
        <div>
          <p className="app-url-view-page-description">
            This url will become the home page for your app on the Drift Apps page! Users will also be able to connect your app from this page within Drift. 
            Note that we won't pass the state parameter if the user is authenticating internally from this page.
          </p>

            <Input
              className="app-url-input"
              value={authUrl}
              readOnly
            />
        </div>
      </div>
    )
  }
}

export default AppUrlView;